/*
 * File: JoinEntryStep.jsx
 * Project: lets-talk-web
 */

/**
 * Imports
 */

// Modules
import React, { forwardRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

// Components
import {
	Button, Typography
} from '../../../../components';

// Styles
import * as S from './JoinEntryStep.styles';


/**
 * Component
 */

export const JoinEntryStep = forwardRef(({
	updateStep, className
}, ref) => {

	// Get actions from hooks
	const navigate = useNavigate();

	// Get current locale from hook
	const stateLocale = useSelector((state) => state.locale.value);

	// Handle login action function
	const loginFunction = () => {
		navigate(`${stateLocale.localePath}/login`);
	};

	// Handle component initialization
	useEffect(() => {}, []);

	// Return component
	return (
		<S.StepContainer ref={ref} className={className}>

			{/* Content */}
			<Typography tag="h2" weight="bold">Sign Up</Typography>
			<Typography tag="p" variation="1" weight="regular">
				Do you have an access code?
			</Typography>

			{/* Actions */}
			<Button
				size="large"
				variation="button2"
				containerClassName="inputSpacer"
				onClick={() => updateStep(2)}
			>
				<S.ButtonContent>
					<span className="title">Have a code?</span>
					<span className="subtitle">Click here</span>
				</S.ButtonContent>
			</Button>

			<Button
				size="large"
				onClick={() => updateStep(4)}
			>
				<S.ButtonContent>
					<span className="title">Request Paid Account</span>
					<span className="subtitle">Click here</span>
				</S.ButtonContent>
			</Button>

			{/* Login Button */}
			<S.BottomActionContainer>
				<Button variant="text" size="small" onClick={loginFunction}>
					<Typography tag="p" variation="2" weight="medium">
						Already have an account?
						{' '}
						<Typography weight="bold">
							Log In
						</Typography>
					</Typography>
				</Button>
			</S.BottomActionContainer>
		</S.StepContainer>
	);
});


/**
 * Configuration
 */

JoinEntryStep.displayName = 'JoinEntryStep';
JoinEntryStep.propTypes = {
	updateStep: PropTypes.func.isRequired,
	className: PropTypes.string
};
JoinEntryStep.defaultProps = {
	className: null
};
